import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { BuilderSections } from '../../util/builder';
import { getGenderFilterConfig } from '../filters/gender';

const joesjeansSizes: string[] = [
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
  '32',
  '33',
  '34',
  '36',
  '38',
  '40',
  '42',
  '44',
];

export const joesjeansShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getBrandDirectFilterConfig(),
    getGenderFilterConfig(),
    getSizeFilterConfig({ sizes: joesjeansSizes }),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: 'f755e04816844237b43473c36bd64d02',
    },
  },
};
